import React from "react";
import PropTypes from "prop-types";

const TabsNav = ({ activeTab, setActiveTab }) => {

    const tabs = [
        { key: "notifications", label: "Notifications" },
        { key: "sales", label: "Ventes" },
        { key: "purchases", label: "Achats" },
        { key: "activities", label: "Activités" },
        { key: "earnings", label: "Gains" },
        { key: "overview", label: "Vue globale" },
    ];

    return (
        <div style={{
            display: "flex",
            gap: 10,
            marginTop: 20,
            overflowX: "auto"
        }}>
            {tabs.map(tab => (
                <div
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                        padding: "10px 16px",
                        borderRadius: 20,
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        background: activeTab === tab.key ? "#1E88E5" : "#E0E0E0",
                        color: activeTab === tab.key ? "#fff" : "#333",
                        transition: "0.3s"
                    }}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
};

TabsNav.propTypes = {
    activeTab: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired
};

export default TabsNav;